import React  from "react";

const Trigger = props => {

    const element = (props.isSub != "true")?
    <React.Fragment><div style={{paddingTop:"0px"}}><label>{props.text}</label></div><div style={{marginLeft:"auto",marginRight:"10px"}}><i className="fa fa-angle-down"></i></div></React.Fragment>:
    <React.Fragment><div className="row col-md-12 p-0 m-0">
    <div className="col-md-9 p-0 m-0" style={{maxWidth:"75%"}}>
      <label style={{fontWeight:"400",fontSize:"16px"}}>                          
    { props.text }
</label>
</div><div style={{marginLeft:"auto",marginRight:"10px"}}><i className="fa fa-minus" style={{fontSize:"15px"}}></i></div>
</div>
</React.Fragment>
    
    const element_close = (props.isSub != "true")?
    <React.Fragment><div style={{paddingTop:"0px"}}><label>{props.text}</label></div><div style={{marginLeft:"auto",marginRight:"10px"}}><i className="fa fa-angle-right"></i></div></React.Fragment>
    :<React.Fragment><div className="row col-md-12 p-0 m-0">
    <div className="col-md-9 p-0 m-0" style={{maxWidth:"75%"}}>
      <label style={{fontWeight:"400",fontSize:"16px"}}>                          
    { props.text }
</label>
</div><div style={{marginLeft:"auto",marginRight:"10px"}}><i className="fa fa-plus" style={{fontSize:"15px"}}></i></div>
</div>
</React.Fragment>
    
 
   
    return (
    <div className="row">        
        {props.isopen == "true" ? element : element_close}
    </div>

    );
    
}

export default Trigger ;

